import {getCookie, setCookie} from 'methods/utils';

const UTM_COOKIE_DAYS = 365;
const IS_PERCENT_COOKIE_DAYS = 1;
const UTM_SOURCE_PATTERN = /^[a-zA-Z0-9_]+$/;
const UTM_VALUE_MAX_LENGTH = 128;

const UTM_PARAM_KEYS = ['utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const IS_PERCENT_UTM_SOURCES = ['dzen', 'retailrocket'];

const PATH_UTM = {
    '/vkontakte/': {
        utm_source: 'vkontakte',
        utm_medium: 'cpc',
    },
    '/resorts/': {
        utm_source: 'resorts',
        utm_medium: 'cpc',
    },
};

function sanitizeUtmValue(value) {
    if (value == null || value === '') {
        return '';
    }

    const str = String(value).trim();

    return str.length > UTM_VALUE_MAX_LENGTH ? str.slice(0, UTM_VALUE_MAX_LENGTH) : str;
}

function getPathUtm() {
    const {pathname} = window.location;

    if (PATH_UTM[pathname]) {
        return PATH_UTM[pathname];
    }

    if (pathname.indexOf('/kurorts/') === 0) {
        return {
            utm_source: 'kurorts',
            utm_medium: 'cpc',
        };
    }

    return null;
}

function setUtmPair(utmSource, utmMedium) {
    setCookie('utm_source', utmSource, UTM_COOKIE_DAYS);

    if (utmMedium != null && utmMedium !== '') {
        setCookie('utm_medium', utmMedium, UTM_COOKIE_DAYS);
    }
}

function saveIsPercentCookie(params) {
    if (params.get('is_percent') === '1') {
        setCookie('is_percent', '1', IS_PERCENT_COOKIE_DAYS);
        return;
    }

    const utmSource = params.get('utm_source');

    if (utmSource && IS_PERCENT_UTM_SOURCES.indexOf(utmSource) !== -1) {
        setCookie('is_percent', '1', IS_PERCENT_COOKIE_DAYS);
    }
}

/**
 * Активен ли фильтр объектов 2–3 воронки (кука или параметр в URL).
 */
export function isPercentFilterActive() {
    if (getCookie('is_percent') === '1') {
        return true;
    }

    return new URLSearchParams(window.location.search).get('is_percent') === '1';
}

/**
 * Сохраняет UTM в куки на 365 дней, is_percent — на сутки.
 */
export function saveUtmCookiesFromUrl(search = window.location.search) {
    const params = new URLSearchParams(search);
    const utmSource = params.get('utm_source');

    saveIsPercentCookie(params);

    if (utmSource && UTM_SOURCE_PATTERN.test(utmSource)) {
        setCookie('utm_source', utmSource, UTM_COOKIE_DAYS);

        UTM_PARAM_KEYS.forEach((key) => {
            if (params.has(key)) {
                setCookie(key, sanitizeUtmValue(params.get(key)), UTM_COOKIE_DAYS);
            }
        });

        if (params.has('rr_mailid_proxy')) {
            setCookie('rr_mailid_proxy', sanitizeUtmValue(params.get('rr_mailid_proxy')), UTM_COOKIE_DAYS);
        }

        return true;
    }

    const pathUtm = getPathUtm();

    if (!pathUtm) {
        return false;
    }

    setUtmPair(pathUtm.utm_source, pathUtm.utm_medium);

    return true;
}

export default saveUtmCookiesFromUrl;
